export const GET_SECTIONS_REQUEST = Symbol('catalog/GET_REQUEST');

export const GET_SECTIONS_SUCCESS = Symbol('catalog/GET_SUCCESS');

export const GET_SECTIONS_FAILURE = Symbol('catalog/GET_FAILURE');

export const REPLACE_PORTIONS = Symbol('catalog/REPLACE_PORTIONS')
